import { createRoot } from 'react-dom/client';
import Markdown from 'react-markdown';

$(() => {
    const summaryDataElement = document.getElementById('js-summary-data');
    const summaryData = summaryDataElement.textContent.trim(); // Remove leading and ending tabs and newlines from the jsp output

    // We intervene a little in the markdown rendering to have links open in a new tab and to set noreferrer.
    // If we start using the markdown renderer other places, it'd probably be worth having our own wrapper class with a
    // property specifying how links should be handled. Seems like overkill while we're only using it one place though.
    const renderLink = function(props) {
        return (
            <a href={props.href} target="_blank" rel="noreferrer">
                {props.children}
            </a>
        );
    };
    const root = createRoot(document.getElementById('campaign-summary'));

    root.render(<div>
        <Markdown components={{a: renderLink}}>{summaryData}</Markdown>
    </div>);
});
